/* ===================================================
   ME knit -- Homepage JavaScript
   One-row product strips: arrows scroll one card at a time
   (loaded on the homepage only, see layout/theme.liquid)
   =================================================== */

(function () {
  'use strict';

  function initScrollRows() {
    document.querySelectorAll('[data-scroll-row]').forEach(function (row) {
      var section = row.closest('section');
      var arrows = section && section.querySelector('[data-row-arrows]');
      if (!arrows) return;
      var prevBtn = arrows.querySelector('[data-row-prev]');
      var nextBtn = arrows.querySelector('[data-row-next]');

      function step() {
        var card = row.querySelector('.product-card');
        var gap = parseFloat(window.getComputedStyle(row).columnGap) || 16;
        return card ? card.offsetWidth + gap : row.clientWidth;
      }

      function updateButtons() {
        arrows.hidden = row.scrollWidth <= row.clientWidth + 5;
        prevBtn.disabled = row.scrollLeft <= 5;
        nextBtn.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 5;
      }

      prevBtn.addEventListener('click', function () {
        row.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        row.scrollBy({ left: step(), behavior: 'smooth' });
      });

      row.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    });
  }

  document.addEventListener('DOMContentLoaded', initScrollRows);
})();
